var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "site-footer media-row"
  }, [_c('div', {
    staticClass: "bigfooter"
  }, [_c('article', {
    staticClass: "foot-menu-container col-md-4"
  }, [_c('h4', {
    staticClass: "content-subtitle"
  }, [_vm._v("Empresa")]), _c('div', {
    staticClass: "page-info"
  }, [_vm._m(0), _c('div', {
    staticClass: "brand-description"
  }, [_c('p', [_vm._v(_vm._s(_vm.appname))]), _c('p', [_vm._v("S.R.L")])])])]), _vm._m(1), _vm._m(2)]), _c('p', {
    staticClass: "copyright-info"
  }, [_vm._v(_vm._s(_vm.appname) + " - © " + _vm._s(_vm.copyRightsYears()) + "  All right reserved| Code and Design with  "), _c('span', {
    staticClass: "love"
  }, [_vm._v(" ❤")]), _vm._v("  by "), _vm._m(3)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "foot-brand"
  }, [_c('img', {
    staticClass: "responsive-img",
    attrs: {
      "src": require("./../assets/img/logo_white.svg")
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "foot-menu-container col-md-5",
    attrs: {
      "id": "contacto"
    }
  }, [_c('h4', {
    staticClass: "content-subtitle"
  }, [_vm._v("Contacto")]), _c('p', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v(" place")]), _vm._v(" C/ Nombre de calle, #0, La Romana, RD")]), _c('p', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v(" phone")]), _vm._v(" 829 000 000")]), _c('p', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v(" mail")]), _vm._v(" me@example.com")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "foot-menu-container col-md-3"
  }, [_c('h4', {
    staticClass: "content-subtitle"
  }, [_vm._v("Redes")]), _c('div', {
    staticClass: "network"
  }, [_c('a', {
    staticClass: "network-ic",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "icon icon-facebook"
  })]), _c('a', {
    staticClass: "network-ic",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "icon icon-twitter"
  })]), _c('a', {
    staticClass: "network-ic",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "icon icon-play"
  })])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "the-company"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://jesusantguerrero.com"
    }
  }, [_vm._v("Insane Code (Jesus Guerrero)")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f41f82c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/src/components/HomeFooter.vue
// module id = 47
// module chunks = 0